module.exports = __webpack_public_path__ + "img/distribution.b61189ce.png";